module.exports = __webpack_public_path__ + "static/img/img12.7be500c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img12.png
// module id = Ph4W
// module chunks = 0